import axios from './api';
import { getUrl } from './utils';

const endPoint = getUrl('api') + '/api/v2/tags';

export const getTagsByProject = async (id) => {
  return axios
    .get(endPoint.concat(`?id_project=${id}&size=1000`))
    .then((res) => res);
};

export const createTag = async (data) => {
  return axios.post(endPoint, data);
};

export const deleteTag = async (id) => {
  return axios.delete(`${endPoint}/${id}`);
};

export const addConcreteBatchToTag = async (tagId, batch, project) => {
  return axios.post(`${endPoint}/batch`, {
    id_tag: tagId,
    batch_code: batch,
    project: project,
  });
};
